//Lays out Header for web app
import React from 'react';

const Header = () => {
  return (
    <header>
      <h1>Nutritional Tracker 2024</h1>
    </header>
  );
};

export default Header;
